const suggestions = ['Jordan', 'Nike', 'Stussy', 'Essentials', 'Yeezy', 'Hoodie'];

export default function SearchSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-2">
          Search the <span className="text-accent-500">Spreadsheet</span>
        </h2>
        <p className="text-sm text-foreground-500 mb-8">
          Find products, sellers, and categories instantly across the entire VigorBuy Spreadsheet database
        </p>

        {/* Search Box */}
        <div className="relative max-w-xl mx-auto mb-6">
          <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
            <i className="ri-search-line text-lg"></i>
          </span>
          <input
            type="text"
            placeholder="Search products, brands, or categories..."
            className="w-full pl-12 pr-4 py-3.5 bg-background-100 border border-background-200 rounded-xl text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-100 transition-all"
          />
        </div>

        {/* Suggestions */}
        <div className="flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-foreground-400 mr-1 whitespace-nowrap">Popular:</span>
          {suggestions.map((s) => (
            <span
              key={s}
              className="px-3 py-1 bg-background-100 border border-background-200 rounded-full text-xs text-foreground-600 whitespace-nowrap hover:border-accent-300 hover:text-accent-600 transition-colors cursor-pointer"
            >
              {s}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}